/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // Prevent cart drawer auto-open on BOTH mobile and desktop after quick add
  // Mobile users use the floating cart button, desktop users use sticky cart icon
  (function() {
    const isMobile = () => window.innerWidth < 768;
    
    // Intercept the theme:product:added event BEFORE theme.js listener fires
    // Using capture phase to run before bubbling phase listeners
    document.addEventListener("theme:product:added", function(e) {
      e.stopImmediatePropagation(); // Block drawer from opening on all devices
      
      // Update cart counts
      fetch('/cart.js')
        .then(res => res.json())
        .then(cart => {
          // Update mobile cart button badge
          if (isMobile()) {
            const mobileBtn = document.getElementById('mobile-cart-button');
            if (mobileBtn) {
              const badge = mobileBtn.querySelector('.mobile-cart-button__badge');
              if (badge) {
                badge.textContent = cart.item_count;
                badge.style.display = cart.item_count > 0 ? 'flex' : 'none';
              }
              
              mobileBtn.classList.add('is-bouncing');
              if (badge) badge.classList.add('is-popping');
              
              setTimeout(() => {
                mobileBtn.classList.remove('is-bouncing');
                if (badge) badge.classList.remove('is-popping');
              }, 500);
            }
          } else {
            // Desktop: update sticky cart icon
            const stickyCount = document.getElementById('sticky-cart-count');
            const stickyCart = document.getElementById('sticky-cart-icon');
            if (stickyCount) {
              stickyCount.textContent = cart.item_count;
              stickyCount.style.display = cart.item_count > 0 ? '' : 'none';
            }
            if (stickyCart) {
              stickyCart.classList.remove('is-bouncing');
              void stickyCart.offsetWidth;
              stickyCart.classList.add('is-bouncing');
              setTimeout(() => stickyCart.classList.remove('is-bouncing'), 500);
            }
          }
          
          // Update header cart count
          document.querySelectorAll('.header__cart__count, .js-cart-count, [data-cart-count]').forEach(el => {
            el.textContent = cart.item_count;
          });
        });
    }, true); // capture phase
  })();

  document.addEventListener("DOMContentLoaded", function() {
    const hubTrigger = document.querySelector(".klaviyo-customer-hub-trigger");
    if (hubTrigger) {
      hubTrigger.addEventListener("click", function(e) {
        e.preventDefault();
        if (window.KlaviyoCustomerHub && window.KlaviyoCustomerHub.toggle) {
          window.KlaviyoCustomerHub.toggle();
        } else {
          // Klaviyo Hub not loaded yet
        }
      });
    }
  });
  
  if (window.location.hash === '#openchat') {
    document.getElementById('commslayer-widget-toggle')?.click();
  }
  // ============================================================
  // Bundle-only protection: block add-to-cart for bundle-only products
  // These products can only be purchased as part of a borderpakket
  // ============================================================
  (function() {
    // Intercept ALL add-to-cart form submissions
    document.addEventListener('submit', function(e) {
      var form = e.target;
      if (!form || form.tagName !== 'FORM') return;
      if (!form.action || form.action.indexOf('/cart/add') === -1) return;

      var container = form.closest('[data-bundle-only]');
      if (!container) return;

      e.preventDefault();
      e.stopImmediatePropagation();
      showBundleOnlyToast(container);
    }, true);

    // Intercept quick-add button clicks for bundle-only products
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('[data-quick-add-btn]');
      if (!btn) return;

      var container = btn.closest('[data-bundle-only]');
      if (!container) return;

      e.preventDefault();
      e.stopImmediatePropagation();
      showBundleOnlyToast(container);
    }, true);

    // When quick-add modal loads content via AJAX, replace with bundle-only message
    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(m) {
        m.addedNodes.forEach(function(node) {
          if (node.nodeType !== 1) return;
          var bundleNotice = node.querySelector ? node.querySelector('.bundle-only-notice') : null;
          if (bundleNotice) {
            var modal = node.closest('[data-quick-add-modal]');
            if (modal) {
              var inner = modal.querySelector('.product-quick-add__inner, [data-product-upsell-ajax]');
              if (inner) {
                while (inner.firstChild) inner.removeChild(inner.firstChild);
                var wrap = document.createElement('div');
                wrap.style.cssText = 'padding:40px 24px;text-align:center;';
                var title = document.createElement('p');
                title.style.cssText = 'font-size:16px;font-weight:700;color:#314540;margin:0 0 8px;';
                title.textContent = 'Enkel beschikbaar in een borderpakket';
                var text = document.createElement('p');
                text.style.cssText = 'font-size:14px;color:#666;margin:0 0 16px;';
                text.textContent = 'Deze plant wordt niet apart verkocht.';
                var link = document.createElement('a');
                link.href = '/collections/borderpakketten';
                link.style.cssText = 'display:inline-block;background:#314540;color:#fff;padding:10px 24px;border-radius:8px;text-decoration:none;font-size:14px;font-weight:600;';
                link.textContent = 'Bekijk onze borderpakketten \u2192';
                wrap.appendChild(title);
                wrap.appendChild(text);
                wrap.appendChild(link);
                inner.appendChild(wrap);
              }
            }
          }
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });

    function showBundleOnlyToast(container) {
      var existing = container.querySelector('.bundle-only-toast');
      if (existing) existing.remove();

      var toast = document.createElement('div');
      toast.className = 'bundle-only-toast';
      toast.style.cssText = 'position:absolute;bottom:100%;left:50%;transform:translateX(-50%);background:#314540;color:#fff;padding:10px 16px;border-radius:8px;font-size:13px;font-weight:600;white-space:nowrap;z-index:9999;box-shadow:0 4px 12px rgba(0,0,0,.15);';
      toast.textContent = 'Enkel beschikbaar in een borderpakket';

      var holder = container.querySelector('.quick-add__holder') || container;
      holder.style.position = 'relative';
      holder.appendChild(toast);
      setTimeout(function() { toast.remove(); }, 3000);
    }
  })();

  // Add custom code above this line
})();

// Prevent cart item remove from redirecting - handle via AJAX instead
(function() {
  document.addEventListener('click', function(e) {
    var removeBtn = e.target.closest('[data-item-remove]');
    if (!removeBtn) return;
    
    e.preventDefault();
    e.stopPropagation();
    
    var itemId = removeBtn.getAttribute('data-id');
    if (!itemId) return;
    
    // Fade out the cart item
    var cartItem = removeBtn.closest('.cart__item');
    if (cartItem) {
      cartItem.style.transition = 'opacity 0.3s ease';
      cartItem.style.opacity = '0.5';
    }
    
    // Remove via AJAX
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: itemId, quantity: 0 })
    })
    .then(function(res) { return res.json(); })
    .then(function(cart) {
      // Dispatch event so theme updates the drawer
      document.dispatchEvent(new CustomEvent('theme:cart:change', { detail: { cart: cart } }));
      
      // Update cart counts
      document.querySelectorAll('.header__cart__count, .js-cart-count, [data-cart-count]').forEach(function(el) {
        el.textContent = cart.item_count;
      });
      
      // Remove the item from DOM
      if (cartItem) {
        cartItem.style.opacity = '0';
        setTimeout(function() { cartItem.remove(); }, 300);
      }
      
      // If cart is empty, reload the drawer content
      if (cart.item_count === 0) {
        location.reload();
      }
    });
  }, true);
})();